import React, { Fragment, useState, useContext, useEffect } from "react";
import PropTypes from "prop-types";
import jQuery from "jquery";
import axios from "axios";
import Cookies from "js-cookie";

import { CodCheckoutButton } from "./CodForm";
import { CartContext } from "components/cart";
import AddToUnlock from "./AddToUnlock";
import OneCheckUpSell from "./OneCheckUpSell";
import ConditionCheck from "./ConditionCheck";
import { API_GATEWAY } from "aws-exports";
import API from "../Api";
import useCampaign from "hooks/useCampaign";
import classNames from "lib/classNames";
import useLocalStorage from "hooks/useLocalStorage";
import ISO6391 from "iso-639-1";
// import { Toast } from '@shopify/app-bridge-react';
import Scary from "./scary";

const CheckoutButton = (props) => {
  const [discount, setDiscount] = useLocalStorage("monster_discount_code", "");
  const [couponOpened, setCouponOpened] = useState(!!discount);
  const [discountLoading, setDiscountLoading] = useState(false);
  const [checkoutLoading, setCheckoutLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const [couponCode, setCouponCode] = useState("");
  const [previewCheckoutToast, setPreviewCheckoutToast] = useState(false);
  const [isTermsAccepted, setIsTermsAccepted] = useState(false);
  const [shakeClass, setShakeClass] = useState("");

  const {
    campaigns,
    cart_settings,
    get_total,
    Utils,
    isPreview,
    shop_url,
    shopify_cart_items,
    shopify_cart_upsells,
    cart_currency,
    productAddedToCart,
    discountCode,
    setDiscountCode,
    isOpened,
    cart_token,
    showCheckoutLoading,
    cartNote,
    slider,
    setPreviewed_product
  } = useContext(CartContext);
  const {
    theme: { secondary, primary, background },
    modules: { checkout_button },
    currency,
    show_coupon,
    show_coupon_alert_text,
    rtl,
    cod_settings = {},
    scary = {},
    checkout_condition_text,
    is_checkout_condition_active,
    checkout_condition_color
  } = cart_settings;

  const applyDiscount = async (code = null) => {
    if (!code) code = couponCode;
    if (!code) return;
    if (isPreview) {
      setDiscount(code);
      setDiscountCode({
        code,
        value: 100
      });
      setCouponCode("");
      return;
    }
    setDiscountLoading(true);
    const { data: checkoutPageDom } = await axios.get(
      generateCheckoutUrl(code)
    );
    const checkoutDom = jQuery(jQuery.parseHTML(checkoutPageDom));
    const hasWarning = checkoutDom
      .find("div.notice.notice--warning")
      .text()
      .trim();
    const hasError = checkoutDom
      .find(".field__message.field__message--error")
      .text()
      .trim();
    if (hasError) {
      setMessage({
        type: "error",
        text: hasError
      });
      setDiscountCode(null);
    } else if (hasWarning) {
      setMessage({
        type: "warning",
        text: hasWarning
      });
      setDiscountCode(null);
    } else {
      setMessage(null);

      const currentSubtotal = get_total("subtotal");
      const newSubtotal = checkoutDom
        .find("[data-checkout-subtotal-price-target]")
        .attr("data-checkout-subtotal-price-target");
      const discountOnHtml = checkoutDom
        .find("[data-checkout-discount-amount-target]")
        .attr("data-checkout-discount-amount-target");

      const discountValue = discountOnHtml
        ? parseInt(discountOnHtml)
        : currentSubtotal - parseInt(newSubtotal);

      if (discountValue > 0) {
        setDiscount(code);
        setDiscountCode({
          code: code,
          value: discountValue
        });
        setCouponCode("");
      }
    }
    setDiscountLoading(false);
  };
  const removeDiscount = () => {
    setDiscountCode(null);
    setDiscount("");
  };

  const generateCheckoutUrl = (discount = null, esid = null) => {
    const wheelioDiscount = Cookies.get("discount_code");
    const queryString = [
      discount && `discount=${encodeURIComponent(discount)}`,
      !discount &&
        wheelioDiscount &&
        `discount=${encodeURIComponent(wheelioDiscount)}`,
      esid && `attributes[esid]=${esid}`
    ].filter(Boolean);
    let langPath = "";
    const pathArray = window.location.pathname.replace(/^\//, "").split("/");
    if (pathArray.length && ISO6391.validate(pathArray[0])) {
      langPath = `/${pathArray[0]}`;
    }
    return `${window.location.origin}${langPath}/checkout${
      queryString.length ? `?${queryString.join("&")}` : ""
    }`;
    // return `https://${shop_url}/cart/${shopify_cart_items
    // 	.map(({ variant_id, quantity }) => `${variant_id}:${quantity}`)
    // 	.join()}${discount ? '?discount=' + discount : ''}`;
  };

  const setNote = () => {
    //update items
    API.post(`${window.location.origin}/cart/update.js`, {
      note: cartNote
    })
      .then(({ data }) => {
        // console.log(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const checkout = () => {
    if (is_checkout_condition_active && !isTermsAccepted) {
      setShakeClass("shake-it");
      if (!shakeClass) {
        setTimeout(() => {
          setShakeClass("");
        }, 900);
      }
      return;
    }
    if (isPreview) {
      setCheckoutLoading(true);
      setPreviewCheckoutToast(true);
      setTimeout(() => {
        setCheckoutLoading(false);
        setPreviewCheckoutToast(false);
      }, 4000);
      return;
    }
    setNote();
    if (window.ttq) {
      window.ttq.track("StartCheckout", {
        value: get_total("subtotal") / 100,
        currency: cart_currency,
        contents: shopify_cart_items.map((item) => ({
          content_type: "product",
          content_name: item.title,
          content_id: item.product_id,
          quantity: item.quantity,
          price: item.price / 100
        }))
      });
    }
    if (discountCode) {
      window.location.href = generateCheckoutUrl(discountCode.code);
      return;
    }
    setCheckoutLoading(true);
    API.post(`${API_GATEWAY}/public/checkout`, {
      shop: shop_url,
      items: shopify_cart_items.map(
        ({ variant_id, product_id, quantity, selling_plan_allocation }) => ({
          variant_id,
          product_id,
          quantity,
          sp: selling_plan_allocation?.selling_plan?.id
        })
      ),
      note: cartNote,
      fbt: shopify_cart_upsells,
      cart_currency,
      token: cart_token,
      discountCode: discount ? discount.title : null
    })
      .then(({ data: { invoice_url, code, esid } }) => {
        Cookies.remove("monster_cart");
        Cookies.remove("monster_product_id");
        if (invoice_url) window.location.href = invoice_url;
        else window.location.href = generateCheckoutUrl(code, esid);
      })
      .catch((error) => {
        setCheckoutLoading(false);
        console.log(error);
      });
  };

  const [one_check_up_sell_product_id, one_check_up_sell] = useCampaign(
    "one_check_up_sell"
  )(campaigns, shopify_cart_items);
  const [add_to_unlock_product_id, add_to_unlock, isGlobal] = useCampaign(
    "add_to_unlock"
  )(campaigns, shopify_cart_items);
  const CAN_RENDER_ADD_TO_UNLOCK =
    add_to_unlock &&
    (add_to_unlock.products.length ||
      add_to_unlock.recommendation_type == "shopify_recommendation" ||
      isPreview) &&
    add_to_unlock.show_suggestions &&
    productAddedToCart({ id: add_to_unlock_product_id });
  // || (isGlobal && shopify_cart_items.length)
  const CAN_RENDER_ONE_CHECK_UP_SELL =
    one_check_up_sell &&
    ((!!Object.keys(one_check_up_sell.product || {}).length &&
      !!one_check_up_sell.text) ||
      isPreview) &&
    productAddedToCart({ id: one_check_up_sell_product_id });

  useEffect(() => {
    if (!isOpened && !isPreview && !discount) setCouponOpened(false);
  }, [isOpened]);

  useEffect(() => {
    if (discount) {
      applyDiscount(discount);
    }
  }, [shopify_cart_items]);

  return (
    <div className={classNames("px-5")}>
      {/* {isPreview && previewCheckoutToast && (
				<Toast content={`This is only a preview button. Visit store for action`} duration={3000} />
			)} */}
      {(!cart_settings.hasOwnProperty("show_coupon") || show_coupon) && (
        <div className={classNames("mb-3")}>
          <div
            style={{
              color: Utils.formatColor(checkout_button.use_coupon_code.color),
              width: "fit-content"
            }}
            className={classNames("font-bold flex items-center cursor-pointer")}
            onClick={() => setCouponOpened(!couponOpened)}
            tabIndex="0"
          >
            <svg
              aria-hidden="true"
              focusable="false"
              className={classNames(
                "transition-transform duration-200 ease-out transform",
                {
                  "rotate-45": couponOpened
                }
              )}
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
              style={{ width: 13, height: 13 }}
            >
              <path
                fill="currentColor"
                d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm144 276c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92h-92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z"
              ></path>
            </svg>

            <div
              className={classNames("leading-full", rtl ? "pr-1" : "pl-1")}
              style={{
                fontSize: couponOpened
                  ? Utils.em(checkout_button.close_coupon_code.font_size)
                  : discount
                  ? Utils.em(checkout_button.edit_coupon_code.font_size)
                  : Utils.em(checkout_button.use_coupon_code.font_size)
              }}
            >
              {couponOpened
                ? checkout_button.close_coupon_code.text
                : discount
                ? checkout_button.edit_coupon_code.text
                : checkout_button.use_coupon_code.text}
            </div>
          </div>
          {couponOpened && (
            <Fragment>
              <div className={classNames("mt-2 flex items-stretch")}>
                <div
                  className={classNames(
                    "flex rounded border p-1 flex items-center flex-1"
                  )}
                  style={{
                    background: Utils.colorAutoBlend(0.05, background),
                    color: Utils.colorAutoBlend(0.7, background),
                    fontSize: Utils.em(
                      checkout_button.enter_coupon_code.font_size
                    ),
                    borderColor: Utils.formatColor(
                      checkout_button.coupon.background
                    )
                  }}
                >
                  <svg
                    aria-hidden="true"
                    focusable="false"
                    className={classNames(
                      rtl ? "pl-2" : "pr-2",
                      "flex-shrink-0"
                    )}
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                    color={Utils.formatColor(checkout_button.coupon.background)}
                    style={{ width: 25, height: 25 }}
                  >
                    <path
                      fill="currentColor"
                      d="M512 256c0-37.7-23.7-69.9-57.1-82.4 14.7-32.4 8.8-71.9-17.9-98.6-26.7-26.7-66.2-32.6-98.6-17.9C325.9 23.7 293.7 0 256 0s-69.9 23.7-82.4 57.1c-32.4-14.7-72-8.8-98.6 17.9-26.7 26.7-32.6 66.2-17.9 98.6C23.7 186.1 0 218.3 0 256s23.7 69.9 57.1 82.4c-14.7 32.4-8.8 72 17.9 98.6 26.6 26.6 66.1 32.7 98.6 17.9 12.5 33.3 44.7 57.1 82.4 57.1s69.9-23.7 82.4-57.1c32.6 14.8 72 8.7 98.6-17.9 26.7-26.7 32.6-66.2 17.9-98.6 33.4-12.5 57.1-44.7 57.1-82.4zm-320-96c17.67 0 32 14.33 32 32s-14.33 32-32 32-32-14.33-32-32 14.33-32 32-32zm12.28 181.65c-6.25 6.25-16.38 6.25-22.63 0l-11.31-11.31c-6.25-6.25-6.25-16.38 0-22.63l137.37-137.37c6.25-6.25 16.38-6.25 22.63 0l11.31 11.31c6.25 6.25 6.25 16.38 0 22.63L204.28 341.65zM320 352c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                    ></path>
                  </svg>
                  {!!discount && (
                    <div
                      className={classNames(
                        "flex px-2 py-1 rounded relative",
                        rtl ? "ml-2 pl-3" : "mr-2 pr-3"
                      )}
                      style={{
                        color: Utils.formatColor(background),
                        background: Utils.formatColor(
                          checkout_button.coupon.background
                        )
                      }}
                    >
                      <span className={classNames("flex-1")}>{discount}</span>
                      <button
                        className={classNames(
                          " w-4 h-4 absolute top-1/2 right-0 p-1 rounded-full  -translate-y-1/2 translate-x-1/2 shadow transform coupon-close"
                        )}
                        style={{
                          background: Utils.formatColor(background)
                        }}
                        onClick={removeDiscount}
                      >
                        <svg
                          aria-hidden="true"
                          focusable="false"
                          role="img"
                          xmlns="http://www.w3.org/2000/svg"
                          data-icon="times"
                          viewBox="0 0 352 512"
                          className={classNames("w-full h-full")}
                          color={Utils.formatColor(
                            checkout_button.coupon.background
                          )}
                        >
                          <path
                            fill="currentColor"
                            d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
                          ></path>
                        </svg>
                      </button>
                    </div>
                  )}
                  {!discount && (
                    <input
                      value={couponCode}
                      placeholder={checkout_button.enter_coupon_code.text}
                      onChange={({ target }) => {
                        if (!discount) setCouponCode(target.value);
                      }}
                      disabled={!!discount}
                      className={classNames(
                        "border-0 shadow-none focus:outline-none bg-transparent w-full"
                      )}
                    />
                  )}
                </div>
                <button
                  onClick={() => applyDiscount()}
                  disabled={!!discount || discountLoading}
                  style={{
                    backgroundColor: Utils.formatColor(
                      checkout_button.coupon.background
                    ),
                    color: Utils.formatColor(
                      checkout_button.apply_coupon_code.color
                    ),
                    fontSize: Utils.em(
                      checkout_button.apply_coupon_code.font_size
                    ),
                    "--hover-background": Utils.formatColor(
                      checkout_button.coupon.hoverBackground
                    ),
                    flex: 0
                  }}
                  className={classNames(
                    rtl ? "mr-2" : "ml-2",
                    "px-3 btn-small flex-0"
                  )}
                >
                  {checkout_button.apply_coupon_code.text}
                </button>
              </div>
              {message && (
                <div
                  className={classNames("py-2 p-1 rounded mt-1", {
                    "bg-yellow-200 border border-yellow-300 text-gray-800":
                      message.type === "warning",
                    "bg-red-200 border border-red-300 text-gray-800":
                      message.type === "error"
                  })}
                >
                  {message.text}
                </div>
              )}
              {discountCode &&
                (!cart_settings.hasOwnProperty("show_coupon_alert_text") ||
                  show_coupon_alert_text) && (
                  <div
                    className={classNames("py-2 italic text-xs text-red-500", {
                      hidden: shop_url === "bandaly.myshopify.com"
                    })}
                    style={{
                      color: checkout_button.coupon_alert_text
                        ? Utils.formatColor(
                            checkout_button.coupon_alert_text.color
                          )
                        : "#ef4444",
                      fontSize: Utils.em(
                        checkout_button.coupon_alert_text
                          ? checkout_button.coupon_alert_text.font_size
                          : 1
                      )
                    }}
                  >
                    {checkout_button.coupon_alert_text
                      ? checkout_button.coupon_alert_text.text
                      : "Code overrides offers"}
                  </div>
                )}
            </Fragment>
          )}
        </div>
      )}
      {get_total("discount") > 0 && (
        <InfoItem
          negative={true}
          name={checkout_button.savings}
          value={get_total("discount")}
        />
      )}
      {scary.isActive && scary.placement === "bottom" && (
        <Scary scary={scary} />
      )}
      <InfoItem name={checkout_button.subtotal} value={get_total("subtotal")} />
      {!!CAN_RENDER_ONE_CHECK_UP_SELL && (
        <OneCheckUpSell {...{ one_check_up_sell }} />
      )}
      {!!is_checkout_condition_active && (
        <ConditionCheck
          {...{
            checkout_condition_text,
            checkout_condition_color,
            isTermsAccepted,
            setIsTermsAccepted,
            Utils,
            rtl,
            shakeClass
          }}
        />
      )}

      {/* normal checkout */}
      {(!cod_settings.is_active ||
        (cod_settings.is_active &&
          cod_settings.checkout_mode === "cod_and_checkout")) && (
        <button
          className={classNames(
            "custom-btn w-full rounded w-full py-3 mb-3 checkout-btn"
          )}
          style={{
            backgroundColor: Utils.formatColor(checkout_button.background),
            fontFamily: "inherit",
            fontSize: Utils.em(checkout_button.button_text.font_size),
            fontWeight: checkout_button.button_text.font_weight,
            color:
              checkoutLoading || showCheckoutLoading
                ? Utils.formatColor(checkout_button.button_text_loading.color)
                : Utils.formatColor(checkout_button.button_text.color),
            "--hover-background": Utils.formatColor(
              checkout_button.hoverBackground
            )
          }}
          onClick={() => checkout()}
          disabled={checkoutLoading || showCheckoutLoading}
        >
          {checkoutLoading || showCheckoutLoading
            ? checkout_button.button_text_loading.text
            : checkout_button.button_text.text}
        </button>
      )}
      {cod_settings.is_active && !cod_settings.is_form_in_cart && (
        <button
          className={classNames("custom-btn w-full rounded w-full py-3 mb-3")}
          style={{
            backgroundColor: Utils.formatColor(
              cod_settings.checkout_button.background
            ),
            fontFamily: "inherit",
            fontSize: Utils.em(cod_settings.checkout_button.font_size),
            color: Utils.formatColor(cod_settings.checkout_button.color),
            "--hover-background": Utils.formatColor(
              cod_settings.checkout_button.hoverBackground
            ),
            border:
              Utils.formatColor(cod_settings.checkout_button.color) +
              " 1px solid"
          }}
          onClick={() => {
            setPreviewed_product(null);
            slider.slickGoTo(1);
          }}
          disabled={checkoutLoading || showCheckoutLoading}
        >
          {cod_settings.checkout_button.text}
        </button>
      )}
      {cod_settings.is_active && cod_settings.is_form_in_cart && (
        <CodCheckoutButton
          {...{
            setNote,
            generateCheckoutUrl,
            discount
          }}
        />
      )}
      {checkout_button.active_continue_shopping_button && (
        <div
          onClick={() => window.closeCart()}
          className={classNames(
            "custom-btn w-full w-full py-2 mb-2 text-center cursor-pointer"
          )}
          style={{
            color: Utils.formatColor(
              checkout_button.continue_shopping_button.color
            ),
            fontSize: `${checkout_button.continue_shopping_button.font_size}em`,
            textDecoration:
              checkout_button.active_continue_shopping_underlined && "underline"
          }}
        >
          {checkout_button.continue_shopping_button.text}
        </div>
      )}
      {!!CAN_RENDER_ADD_TO_UNLOCK && (
        <AddToUnlock {...{ add_to_unlock, add_to_unlock_product_id }} />
      )}
    </div>
  );
};

const InfoItem = ({
  name: { text, font_size, color , font_weight},
  value,
  negative = false
}) => {
  const {
    Utils,
    cart_settings: { money_format }
  } = useContext(CartContext);
  // const original = get_total('discount') > 0 ? get_total('original') : null;
  return (
    <div
      className={classNames("pb-3 flex items-center font-bold info-item")}
      style={{
        fontSize: Utils.em(font_size),
        fontWeight: font_weight,
        color: Utils.formatColor(color)
      }}
    >
      <span className={classNames("flex-1 flex-grow")}>{text}</span>
      <AnimatedNumber
        component="span"
        value={value}
        formatValue={(n) =>
          `${negative ? "-" : ""}${Utils.formatMoney(n, money_format)}`
        }
      />
    </div>
  );
};

const AnimatedNumber = ({ value, style = {}, formatValue = null }) => (
  <span
    {...{ style }}
    dangerouslySetInnerHTML={{
      __html: formatValue ? formatValue(value) : value
    }}
  />
);

CheckoutButton.propTypes = {};

export default CheckoutButton;
